/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.templates.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition'
])

.controller('EntitiesTemplatesController', ['$scope', '$state', '$timeout', '$log', 'ApiService', 'PermissionsService', 'HelpersService', 'ValidateService', 'GridStateFactory','GridDefinitionFactory', 'preferenceKey', function($scope, $state, $timeout, $log, ApiService, PermissionsService, HelpersService, ValidateService, GridStateFactory, GridDefinitionFactory, preferenceKey) {

    $scope.entitiesTemplates = {

      model: [],
      errors: {},
      entityType: {},
      searchQuery: '',
      entitiesTemplateGridName: $state.current.name + '.grid0',

      removeIndex: -1,
      showErrors: false,
      errorTimer: false,
      isLoaded: false,
      searchTimer: false,
      grid: {
        appScopeProvider: {
          onDataGridSortChange: function(grid, columns) {
            $scope.entitiesTemplates.onDataGridSortChange(grid, columns);
          },
          onDataGridPaginate: function(newPageNumber, newPageSize) {
            $scope.entitiesTemplates.onDataGridPaginate(newPageNumber, newPageSize);
          },
          onDblClick: function(row) {
            $scope.entitiesTemplates.gridDoubleClick(row);
          }
        },
        useExternalPagination: true,
        useExternalSorting: true,
        data: 'entitiesTemplates.model',
        pageSize: 25,
        enableGridMenu: false,
        showFooter: true,
        paginate: true,
        columnDefs: [
          {
            field: 'edit',
            displayName: 'Edit',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.entitiesTemplates.gridDoubleClick(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
            visible: false,
            enableHiding: false,
            enableSorting: false
          },
          {
            field: 'name',
            displayName: 'Name'
          },
          {
            field: 'description',
            displayName: 'Description',
            enableSorting: false
          }
        ]
      },

      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      init: function() {
        var enablePreferences = $state.$current.data && $state.$current.data.enablePreferences;

        this.viewId = [$state.current.name, preferenceKey].join('.');
        this.gridDefinition.init(this.entitiesTemplateGridName, this.grid, this.viewId, enablePreferences);
        if ($state.params && $state.params.type) {

          this.entityType = HelpersService.getEntityName($state.params.type);
          if (!PermissionsService.check('ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_VIEW')) {
            console.log('ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_VIEW');
            $state.go('home.default', {}, { notify: true });
          }
          this.grid.columnDefs[0].visible = PermissionsService.check('ENTITY_TEMPLATE_' + $scope.entitiesTemplates.entityType.singular.toUpperCase() + '_UPDATE');

          $scope.$emit('Application::contentTitleChange', {
            title: HelpersService.cap(this.entityType.displayPlural) + ' Types',
            buttonRight: {
              label: '+ Create Type',
              permissions: 'ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_CREATE',
              action: function () {
                $state.go('application.entities.templates.create');
              }
            }
          });


          $scope.$emit('AppController::updateTitle', {
            title: HelpersService.cap(this.entityType.displayPlural) + ' Types'
          });

          // Subscribe to listeners
          $scope.$on('ResourcesCreateController::success', function () {
            $scope.entitiesTemplates.getTemplates($scope.entitiesTemplates.entityType.plural);
          });

          $scope.$on('ResourcesUpdateTemplate::success', function () {
            $scope.entitiesTemplates.getTemplates($scope.entitiesTemplates.entityType.plural);
          });

          $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

        }
      },

      initData: function() {
        var self = $scope.entitiesTemplates, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getTemplatesQuery();
      },

      getTemplates: function(type) {
        ApiService.resource.templates($.extend({ resourceCategory: HelpersService.cap(type) }, this.gridState.getGridState())).then(this.success.getTemplates, this.error.getTemplates);
      },

      getTemplatesQuery: function() {

        var self = $scope.entitiesTemplates,
            query = self.gridState.getGridState();

        this.isListLoaded = false;
        this.grid.page = 1;
        this.gridState.setPropertyValue('page', this.grid.page);

        HelpersService.decorate(query, {
          search: this.searchQuery,
          page: this.grid.page
        });

        if (this.searchTimer) {
          $timeout.cancel(this.searchTimer);
        }

        this.searchTimer = $timeout(function () {
          self.getTemplates($state.params.type);
        }, 500);

      },

      getDeletePermission: function() {
        return 'ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_DELETE';
      },

      getUpdateSref: function(templateId) {
        var r = '.';

        if (PermissionsService.check('ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_UPDATE')) {
          r = 'application.resourcesDetail({ id: \''+templateId+'\' })';
        }
        return r;
      },

      getEmptyImage: function() {
        var r;

        switch(this.entityType.plural) {
          case 'facilities':
            uuid = '5afa7c3a-e2ea-4d73-8d53-0e0788a84076';
            break;
          case 'personnel':
            uuid = '09728cd8-2be9-4966-8ca3-7cfe0ef9e5c9';
            break;
          case 'equipment':
            uuid = '21583c37-a424-4f27-b3b6-fdc3bdb437bc';
            break;
        }

        return r = '/v1/api/photos/'+uuid+'/PM';
      },

      removeTemplate: function(id, index) {
        if (PermissionsService.check('ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_DELETE')) {
          this.removeIndex = index;
          ApiService.resource.remove(id).then(this.success.removeTemplate, this.error.removeTemplate);
        }
      },

      gridDoubleClick: function(item) {
        if (PermissionsService.check('ENTITY_TEMPLATE_' + $scope.entitiesTemplates.entityType.singular.toUpperCase() + '_VIEW')) {
          $state.go('application.entities.templates.edit', { id: item.entity.id });
        }
      },

      onDataGridPaginate: function (newPageNumber, pageSize) {
        var self = $scope.entitiesTemplates;

        self.gridState.updateGridState(newPageNumber, pageSize);

        self.getTemplates($state.params.type);
      },

      onDataGridSortChange: function (grid, columns) {
        var self = $scope.entitiesTemplates,
            data = columns[0],
            query = {};

        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
        }

        self.getTemplates($state.params.type);
      },

      onsearchQueryUpdate: function() {
        $scope.entitiesTemplates.getTemplatesQuery();
      },

      // Success Callbacks for all requests
      success: {

        getTemplates: function(response, status, headers, config) {
          var self = $scope.entitiesTemplates;

          self.isLoaded = true;
          self.showErrors = false;
          self.model = response.data.payload.list;
          self.grid.totalItems = response.data.payload.pagination.count;
          self.gridDefinition.isLoaded = true;
          self.gridState.updateGridState(null, null, null, null, null, self.grid.totalItems);
          $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: self.grid.totalItems});
        },

        removeTemplate: function(response, status, headers, config) {
          var self = $scope.entitiesTemplates;

          self.showErrors = false;
          if (self.removeIndex !== -1) {
            self.model.splice(self.removeIndex, 1);
            self.removeIndex = -1;
          }
        }
      },

      // Error Callbacks for all requests
      error:  {

        getTemplates: function(response, status, headers, config) {
          //TODO: Need to handle this
          var self = $scope.entitiesTemplates;

          self.isLoaded = true;
        },

        removeTemplate: function(response, status, headers, config) {

          var self = $scope.entitiesTemplates;

          console.log('removeTemplate: ', self.removeIndex);
          self.showErrors = true;
          self.errors[self.removeIndex] = [{
            message: "Unable to remove: " + self.model[self.removeIndex].name
          }];

          switch(response.status) {
            case 402:
              self.errors[self.removeIndex].push({
                message: "Type is in use."
              });
              break;
          }

          self.errorTimer = $timeout(function() {
            self.showErrors = false;
            self.errors[self.removeIndex] = {};
            self.removeIndex = -1;
          }, 5000);

        }
      }

    };

    $scope.entitiesTemplates.init();

}]);
